import {apiList, $axios} from "@/api";

export default {
    state: {
        activePeriod: {
            value: "Месяц",
            key: "month"
        },
        currentDate: null,
        activeView: true,
        selectedDate: null,
        eventsForList: [],
        filtersEvents: [
            {
                label: 'Сайт',
                state: true,
                value: 'site'
            },
            {
                label: 'Категория',
                state: true,
                value: 'category'
            },
            {
                label: 'Курс',
                state: true,
                value: 'course'
            },
            {
                label: 'Группа',
                state: true,
                value: 'group'
            },
            {
                label: 'Пользователь',
                state: true,
                value: 'user'
            },
            {
                label: 'Другое',
                state: true,
                value: 'other'
            },
        ]
    },

    mutations: {
        mutateFilters(state, el) {
            state.filtersEvents = state.filtersEvents.map(_el => {
                if (_el.label === el.label) {
                    return el
                }
                return _el
            })
        },
        setSwitchView(state, value) {
            state.activeView = value
        },
        setActivePeriod(state, value) {
            state.activePeriod = value
        },
        setEventsForList(state, value) {
            state.eventsForList = value
        },
        setCurrentDate(state, value) {
            state.currentDate = value
        },
        setSelectedDate(state, date) {
            state.selectedDate = date
        }
    },

    getters: {
        filtersEvents: state => state.filtersEvents,
        switchView: state => state.activeView,
        activePeriod: state => state.activePeriod,
        eventsForList: state => state.eventsForList,
        currentDate: state => state.currentDate
    },

    actions: {
        setEventsForList({commit}, payload) {
            commit('setEventsForList', payload)
        },
        getCalendarMonthInfo(_, {year, month}) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.calendar.getMonthInfo.method,
                    params: {
                        wsfunction: apiList.calendar.getMonthInfo.moodle_method,
                        year: year,
                        month: month
                    },
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        getCalendarDayInfo(_, {year, month, day}) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.calendar.getDayInfo.method,
                    params: {
                        wsfunction: apiList.calendar.getDayInfo.moodle_method,
                        year: year,
                        month: month,
                        day: day
                    },
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        getCalendarEvents() {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.calendar.getCalendarEvents.method,
                    params: {
                        wsfunction: apiList.calendar.getCalendarEvents.moodle_method,
                    },
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        getUpcomingEvents() {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.calendar.getUpcomingEvents.method,
                    params: {
                        wsfunction: apiList.calendar.getUpcomingEvents.moodle_method,
                    },
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        getSwitchView({commit}, value) {
            commit('setSwitchView', value)
        },
        setActivePeriod({commit}, item) {
            commit('setActivePeriod', item)
        }

    }
}
